<span [innerHTML]="question.information"></span>
